import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Apple, Loader2 } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { APP_STORE_URL, trackCtaClick } from "@/data/appLinks";

/**
 * Short shareable link: airportbuddy.app/app
 * Records the tap, then hands off to the App Store.
 */
const AppRedirect = () => {
  const [params] = useSearchParams();
  const source = params.get("s") || params.get("source") || undefined;

  useEffect(() => {
    trackCtaClick("short_link", source);
    const timer = setTimeout(() => {
      window.location.replace(APP_STORE_URL);
    }, 400);
    return () => clearTimeout(timer);
  }, [source]);

  return (
    <>
      <Helmet>
        <title>Get Airport Buddy for iPhone | Live TSA Wait Times</title>
        <meta
          name="description"
          content="Download Airport Buddy free on iPhone for live TSA wait times, a leave-by timer, and gate-change alerts."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center bg-background">
        <Apple className="h-10 w-10 text-primary" aria-hidden="true" />
        <h1 className="text-2xl font-bold text-foreground">Opening the App Store…</h1>
        <p className="text-base text-muted-foreground">
          Taking you to Airport Buddy for iPhone.
        </p>
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" aria-hidden="true" />
        <a
          href={APP_STORE_URL}
          className="text-base text-primary hover:underline min-h-[44px] inline-flex items-center"
        >
          Tap here if nothing happens
        </a>
      </div>
    </>
  );
};

export default AppRedirect;
